<template>
    <ion-grid class="swipable">
        <ion-row class="content-row" align-items-center>
            <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center>
                <ion-card>
                    <ion-card-header>
                        <ion-card-title text-left color="primary">{{ $t('components.alert-region.title') }}</ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <ion-card v-for="region in regions" v-bind:key="region.id" class="region" @click="selectRegion(region.id)">
                            <ion-item lines="none"><ion-thumbnail><ion-img :src="region.img"></ion-img></ion-thumbnail><ion-label>{{region.name}}</ion-label><ion-icon class="arrow" name="arrow-forward" mode="ios" size="small" slot="end"></ion-icon></ion-item>
                        </ion-card>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script>
    export default {
        name: 'AlertRegion',
        props: {
            from_id: String,
        },
        data() {
            return {
                regions: [
                    {id: "R-AF", name: 'Africa', img: require('@/assets/monument-icons/jir.svg')},
                    {id: "R-CB", name: 'Caribbean', img: require('@/assets/monument-icons/car.svg')},
                    {id: "R-EU", name: 'Europe', img: require('@/assets/city-icons/par.svg')},
                    {id: "R-IN", name: 'India', img: require('@/assets/monument-icons/taj.svg')},
                    {id: "R-JP", name: 'Japan', img: require('@/assets/monument-icons/sus.svg')},
                    {id: "R-MD", name: 'Mediterranean', img: require('@/assets/city-icons/bcn.svg')},
                    {id: "R-ME", name: 'Middle East', img: require('@/assets/monument-icons/bur.svg')},
                    {id: "R-NA", name: 'North America', img: require('@/assets/monument-icons/who.svg')},
                    {id: "R-SA", name: 'South America', img: require('@/assets/city-icons/rio.svg')},
                    {id: "R-SS", name: 'Southeast Asia', img: require('@/assets/monument-icons/awa.svg')},
                    {id: "R-OC", name: 'Oceania', img: require('@/assets/city-icons/yqy.svg')}
                ]
            }
        },
        methods: {
            selectRegion: function(id) {
                this.$AmplifyEventBus.$emit('addAlertProgress', {step: 'dates', value: id});
                this.$router.push({name: 'add-alert-date', params: {to_type: 2, to_id: id, from_id: this.from_id} });
            }
        }
    }
</script>

<style scoped>
    ion-thumbnail {
        height: 2.7em;
        width: 2.7em;
        margin: .3em .8em .3em 0em;
    }

    ion-thumbnail ion-img {
        height: 2.7em;
        object-fit: contain;
    }

    ion-button ion-icon {
        margin-right: .5em;
    }

    .content-row .logo {
        height: 2em;
    }

    .region {
        padding: 0;
        margin-bottom: 0;
    }

    .region:last-of-type {
        margin-bottom: 1em;
    }

    .region ion-item {
        --inner-padding-end: .5em;
        --padding-start: .5em;
        margin: 0;
        cursor: pointer;
    }

    .region:hover {
        background-color: #ffccdd;
    }

    .region ion-label {
        color: #666;
        font-size: 1em;
        margin: 0;
    }

    .region ion-icon {
        margin: 0;
    }

    .region .arrow {
        margin-left: .5em;
    }

    .divider {
        margin: .2em auto;
    }
</style>